<h2 mat-dialog-title>{{confirmDialogContent.title | translate}}</h2>
<mat-dialog-content class="mat-typography">{{confirmDialogContent.confirmMessage | translate}}
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{confirmDialogContent.cancelButtonText | translate}}</button>
    <button mat-button color="warn" [mat-dialog-close]="true">{{confirmDialogContent.confirmButtonText | translate}}</button>
</mat-dialog-actions>
